import React from 'react';
import evemts from 'utils/evemts';
import http from 'utils/http';
import { setDeleteAction } from 'store/actions/deleteAction';
import { connect } from 'react-redux';
import EmailTemplate from './EmailTemplate';

class EmailTemplateContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mails: [],
      mailFields: {},
      mailFieldsErrors: {},
      footer: '',
      cc: '',
      ccList: '',
      bcc: '',
      bccList: '',
      footerErrors: false,
      ccErrors: {},
      bccErrors: {},
      modal: false,
      emailAnchorEl: null,
      activeEmailField: null,
      bounce: '',
      bounceErrors: {},
    };
    this.eventSource = null;
  }

  componentDidMount() {
    this.fetchMailTemp();
    this.fetchMailFooter();
    this.fetchMailCC();
    this.fetchMailBCC();
    this.fetchBounce();
    this.eventSource = evemts('admin', 'import');
    this.eventSource.onmessage = (event) => {
      const msg = JSON.parse(event.data || '{}');
      if (msg.data && msg.action && msg.action == 'mail_temp') {
        this.setState({ mails: msg.data?.value || [] });
      }

      if (msg.data && msg.action && msg.action == 'mail_footer') {
        this.setState({ footer: msg.data?.value?.footer || '' });
      }

      if (msg.data && msg.action && msg.action == 'mail_cc') {
        this.setState({ ccList: msg.data?.value?.cc || '' });
      }

      if (msg.data && msg.action && msg.action == 'mail_bcc') {
        this.setState({ bccList: msg.data?.value?.bcc || '' });
      }
      
      if (msg.data && msg.action && msg.action == 'mail_bounce') {
        this.setState({ bounceList: msg.data?.value?.bounce || '' });
      }
    };
  }

  componentWillUnmount() {
    if (this.eventSource) {
      this.eventSource.close();
    }
  }

  openEmailPopover = (field) => (e) => {
    this.setState({
      activeEmailField: field,
      emailAnchorEl: e.currentTarget,
    });
  };

  closeEmailPopover = () => {
    this.setState({
      emailAnchorEl: null,
      activeEmailField: null,
    });
  };

  fetchMailTemp = () => {
    http.get('/settings?key=mail_temp').then(({ data }) => {
      if (data.data) {
        let mail = data.data?.find((item) => item.key === 'mail_temp');
        if (mail) {
          this.setState({ mails: mail?.value || [] });
        }
      }
    }
    );
  };

  fetchMailFooter = () => {
    http.get('/settings?key=mail_footer').then(({ data }) => {
      if (data.data) {
        let footer = data.data?.find((item) => item.key === 'mail_footer');
        if (footer) {
          this.setState({ footer: footer?.value?.footer || '' });
        }
      }
    });
  };

  fetchMailCC = () => {
    http.get('/settings?key=mail_cc').then(({ data }) => {
      if (data.data) {
        let cc = data.data?.find((item) => item.key === 'mail_cc');
        if (cc) {
          this.setState({ ccList: cc?.value?.cc || '' });
        }
      }
    });
  };

  fetchMailBCC = () => {
    http.get('/settings?key=mail_bcc').then(({ data }) => {
      if (data.data) {
        let bcc = data.data?.find((item) => item.key === 'mail_bcc');
        if (bcc) {
          this.setState({ bccList: bcc?.value?.bcc || '' });
        }
      }
    });
  };

  handleOpen = (modal, anchorEl = null, modalData = null) => {
    this.setState({
      modal,
      anchorEl,
      modalData
    });
  };

  handleClose = () => {
    this.setState({
      modal: false,
      anchorEl: null,
      modalData: false,
      mailFields: {},
      mailFieldsErrors: {}
    });
  };

  onPreviewClick = () => {
    const previewSection = document.getElementById('mail-preview-section');
    if (previewSection) {
      previewSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  onChangeMail = (e) => {
    let value = e.target.value;
    if (e.target.type == 'checkbox') {
      value = e.target.checked;
    }
    this.setState({
      mailFields: {
        ...this.state.mailFields,
        [e.target.name]: value,
      },
    });
  };

  validateMailForm = () => {
    let mailFieldsErrors = {};
    let isValid = true;
    if (!this.state.mailFields.type) {
      mailFieldsErrors.type = true;
      isValid = false;
    }
    if (this.state.mailFields.type == 'Text' || this.state.mailFields.type == 'Text SPL') {
      if (!this.state.mailFields.name) {
        mailFieldsErrors.name = true;
        isValid = false;
      }
      if (!this.state.mailFields.value) {
        mailFieldsErrors.value = true;
        isValid = false;
      }
    }
    if(this.state.mailFields.type == 'Text SPL' && !this.state.mailFields.condition_spl) {
      mailFieldsErrors.condition_spl = true;
      isValid = false;
    }
    this.setState({ mailFieldsErrors });
    return isValid;
  };

  swap = (direction, index) => {
    let data = {
      index: index,
      up: direction == 'up' ? true : false,
      down: direction == 'down' ? true : false,
    };
    http.put('/setting/mail_temp/swap', data);
  };

  onRowMailClick = (row) => {
    this.setState({
      mailFields: {
        ...row,
        old_name: row.name 
      },
      mailFieldsErrors: {}
    });
  };

  editMail = (e) => {
    e.preventDefault();
    if (this.validateMailForm()) {
      let data = {
        type: this.state.mailFields.type,
        name: this.state.mailFields.name || null,
        old_name: this.state.mailFields.old_name || null,
        value: this.state.mailFields.value || null,
        condition_spl: this.state.mailFields.condition_spl? this.state.mailFields.condition_spl?.toUpperCase() : null,
      };
      http.put('setting/mail_temp', data).then(({ data }) => {
        if (data.status == 'success') {
          this.setState((prevState) => ({
            modal: false,
            mailFields: {
              ...prevState.mailFields,
              type: '',
              name: '',
              value: '',
              condition_spl: '',
            }
          }));
        }
      }).catch(error => {
        console.error('Error fetching data:', error);
      });
    }
  };

  handleDeleteMail = (id, anchorEl) => {
    this.props.setDelete({
      modal: true,
      id,
      anchorEl,
      onConfirm: () => this.deleteMail(id),
    });
  };

  deleteMail = (id) => {
    http.delete('setting/mail_temp/' + id).then(({ data }) => {
      if (data.status == 'success') {
        this.props.setDelete({
          modal: false,
          id: false,
          anchorEl: false,
          onConfirm: () => { },
        });
      }
    });
  };

  onChangeFooter = (e) => {
    let value = e.target.value;
    if (e.target.type == 'checkbox') {
      value = e.target.checked;
    }
    this.setState({
      footer: value,
      footerErrors: false,
    });
  };

  onChangeCC= (e) => {
    let value = e.target.value;
    this.setState({
      cc: value,
      ccErrors: {},
    });
  };

  onChangeBCC= (e) => {
    let value = e.target.value;
    this.setState({
      bcc: value,
      bccErrors: {},
    });
  };

  validateEmailList = (inputValue, existingValue, key) => {
    const inputEmails = (inputValue || '').split(',').map((email) => email.trim()).filter(Boolean);
    if (!inputEmails.length) {
      return {
        isValid: false,
        error: { [key]: 'Enter valid email' }
      };
    }

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const hasInvalidEmail = inputEmails.some((email) => !emailRegex.test(email));
    if (hasInvalidEmail) {
      return {
        isValid: false,
        error: { [key]: 'Enter valid email' }
      };
    }

    const existingEmails = (existingValue || '').split(',').map((email) => email.trim()).filter(Boolean);
    const duplicateEmails = inputEmails.filter((email) =>
      existingEmails.some((existingEmail) => existingEmail.toLowerCase() === email.toLowerCase())
    );
    if (duplicateEmails.length) {
      return {
        isValid: false,
        error: { [key]: `Duplicate emails: ${duplicateEmails.join(', ')}` }
      };
    }

    return {
      isValid: true,
      inputEmails,
      existingEmails
    };
  };

  saveMailFooter = (e) => {
    e.preventDefault();
    if (!this.state.footer) {
      this.setState({ footerErrors: true });
    } else {
      http.put('setting/mail_footer', { value: { footer: this.state.footer } });
    }
  };

  saveMailCC = (e) => {
    e.preventDefault();
    const result = this.validateEmailList(this.state.cc, this.state.ccList, 'cc');
    if (!result.isValid) {
      this.setState({ ccErrors: result.error });
      return;
    }
    const updatedCcList = [...result.existingEmails, ...result.inputEmails].join(',');
    http.put('setting/mail_cc', { value: { cc: updatedCcList } }).then(({ data }) => {
      if (data.status == 'success') {
        this.setState({
          cc: '',
          ccList: updatedCcList,
          ccErrors: {},
        });
      }
    });
  };

  saveMailBCC = (e) => {
    e.preventDefault();
    const result = this.validateEmailList(this.state.bcc, this.state.bccList, 'bcc');
    if (!result.isValid) {
      this.setState({ bccErrors: result.error });
      return;
    }
    const updatedBccList = [...result.existingEmails, ...result.inputEmails].join(',');
    http.put('setting/mail_bcc', { value: { bcc: updatedBccList } }).then(({ data }) => {
      if (data.status == 'success') {
        this.setState({
          bcc: '',
          bccList: updatedBccList,
          bccErrors: {},
        });
      }
    });
  };

  onDeleteCCEmail = (email) => {
    const updatedCcList = (this.state.ccList || '')
      .split(',')
      .map((item) => item.trim())
      .filter(Boolean)
      .filter((item) => item.toLowerCase() != email.toLowerCase())
      .join(',');

    this.setState({ ccList: updatedCcList }, () => {
      http.put('setting/mail_cc', { value: { cc: updatedCcList } });
    });
  };

  onDeleteBCCEmail = (email) => {
    const updatedBccList = (this.state.bccList || '')
      .split(',')
      .map((item) => item.trim())
      .filter(Boolean)
      .filter((item) => item.toLowerCase() != email.toLowerCase())
      .join(',');

    this.setState({ bccList: updatedBccList }, () => {
      http.put('setting/mail_bcc', { value: { bcc: updatedBccList } });
    });
  };

  fetchBounce =() => {
    http.get('/settings?key=mail_bounce').then(({ data }) => {
      if (data.data) {
        let bounce = data.data?.find((item) => item.key === 'mail_bounce');
        if (bounce) {
          this.setState({ 
            // bounce: bounce?.value?.bounce || '',
            bounceList: bounce?.value?.bounce || '', 
          });
        }
      }
    });
  };
    
  onChangeBounce= (e) => {
    let value = e.target.value;
    this.setState(() => ({
      bounce: value,
      bounceErrors: {},
    }));
  };
    
  saveMailBounce = (e) => {
    if (e) {
      e.preventDefault();
    }
    const result = this.validateEmailList(this.state.bounce, this.state.bounceList, 'bounce');
    if (!result.isValid) {
      this.setState({ bounceErrors: result.error });
      return;
    }

    const updatedBounceList = [...result.existingEmails, ...result.inputEmails].join(',');
    http.put('setting/mail_bounce', { value: { bounce: updatedBounceList } }).then(({ data }) => {
      if (data.status == 'success') {
        this.setState({
          bounceList: updatedBounceList,
          bounceErrors: {},
          bounce: '',
        });
      }
    });
  };

  onDeleteBounceEmail = (email) => {
    const updatedBounceList = (this.state.bounceList || '')
      .split(',')
      .map((item) => item.trim())
      .filter(Boolean)
      .filter((item) => item.toLowerCase() != email.toLowerCase())
      .join(',');

    this.setState({ bounceList: updatedBounceList }, () => {
      http.put('setting/mail_bounce', { value: { bounce: updatedBounceList } });
    });
  };

  render() {
    return (
      <>
        <EmailTemplate
          mails={this.state.mails}
          onChangeMail={this.onChangeMail}
          mailFields={this.state.mailFields}
          mailFieldsErrors={this.state.mailFieldsErrors}
          onRowMailClick={this.onRowMailClick}
          swap={this.swap}
          handleDeleteMail={this.handleDeleteMail} 
          editMail={this.editMail}
          footer={this.state.footer}
          footerErrors={this.state.footerErrors}
          onChangeFooter={this.onChangeFooter}
          saveMailFooter={this.saveMailFooter}
          cc={this.state.cc}
          ccList={this.state.ccList}
          ccErrors={this.state.ccErrors}
          onChangeCC={this.onChangeCC}
          saveMailCC={this.saveMailCC}
          onDeleteCCEmail={this.onDeleteCCEmail}
          bcc={this.state.bcc}
          bccList={this.state.bccList}
          bccErrors={this.state.bccErrors}
          onChangeBCC={this.onChangeBCC}
          saveMailBCC={this.saveMailBCC}
          onDeleteBCCEmail={this.onDeleteBCCEmail}
          // bounce email
          bounce={this.state.bounce}
          bounceErrors={this.state.bounceErrors}
          onChangeBounce={this.onChangeBounce}
          saveMailBounce={this.saveMailBounce}
          onDeleteBounceEmail={this.onDeleteBounceEmail}
          handleOpen={this.handleOpen}
          handleClose={this.handleClose}
          onPreviewClick={this.onPreviewClick}
          modal={this.state.modal}
          bounceList={this.state.bounceList}
          emailAnchorEl={this.state.emailAnchorEl}
          activeEmailField={this.state.activeEmailField}
          openEmailPopover={this.openEmailPopover}
          closeEmailPopover={this.closeEmailPopover}
        />
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return { setDelete: (data) => dispatch(setDeleteAction(data)) };
};

export default connect(null, mapDispatchToProps)(EmailTemplateContainer);